module.exports = __webpack_public_path__ + "media/38.83ada714.mp3";